import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Model_DataSource_Search_Fields: {[id:string]: ISearchProviderField} = {
    WB_MODEL_DATASOURCE_ID:         {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Model DataSource Id',       columnResourceName: 'colId',              alignment: HorizAlignment.Left},  domainOptions: {}},
    DATASOURCE_NAME:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Model DataSource Name',        columnResourceName: 'colName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    DATASOURCE_ID:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Model DataSource Id',          columnResourceName: 'colPId',          alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    TARGET_TABLENAME:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Target Table Name',        columnResourceName: 'colType',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    TARGET_FIELDNAME:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Target Field Name',      columnResourceName: 'colAgrMed',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CUSTOMER_FIELDNAME:                   {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Customer Field Name',             columnResourceName: 'colNumberType',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    PRODUCT_FIELDNAME:                 {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Product Field Name'       ,       columnResourceName: 'colSort',        alignment: HorizAlignment.Right},  domainOptions: {}},CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    WB_TREE_FOLDER_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Tree Folder'}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const ModelDataSourceSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_MODEL_DATASOURCE_ID',
        id_ui: 'DATASOURCE_ID',
        name: 'DATASOURCE_NAME'

    },

    searchProviderFields: vUI_Model_DataSource_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_DataSource_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const ModelDataSourceSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "ModelDataSourceSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'DATASOURCE_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'DATASOURCE_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'DATASOURCE_NAME', 'DATASOURCE_ID', 'TARGET_TABLENAME', 'TARGET_FIELDNAME', 'CUSTOMER_FIELDNAME', 'PRODUCT_FIELDNAME',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelDataSourceSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelDataSourceSearch: ISearch = {
    searchName: "Find Model DataSource",
    renderOptions: {ui5ResourceId: "ModelDataSourceSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ModelDataSourceSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ModelDataSourceBO", "ModelDataSource", ModelDataSourceSearch, "Model DataSource Search")

export {ModelDataSourceSearch}
